import { StageKey } from './processStage.types';
import { RichTextBlock } from 'prismic-reactjs';
import {
  ProcessStageText,
  ProcessStageTitle,
  StageWrapper,
} from '../processStage.styles';

type Props = {
  position: 'TOP' | 'BOTTOM';
  index: number;
  stageKey: StageKey;
  title: string;
  image: RichTextBlock;
  stageDescription: string;
};

export const ProcessStage = ({
  position,
  index,
  stageKey,
  title,
  image,
  stageDescription,
}: Props) => {
  return (
    <StageWrapper position={position} imageUrl={image.url!}>
      <ProcessStageText>{stageDescription}</ProcessStageText>
      <ProcessStageTitle>{title}</ProcessStageTitle>
    </StageWrapper>
  );
};
